// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, BehaviorSubject } from 'rxjs';

// --- HS Code
import { NotificationModel, Constants } from '../../../models';
import { map } from 'rxjs/operators';

// #endregion

@Injectable({
  providedIn: 'root'
})
export abstract class UserNotificationBaseService {
  protected _notificationList: NotificationModel[];
  protected _notifications$: BehaviorSubject<NotificationModel[]>;
  get notifications$(): Observable<NotificationModel[]> {
    return this._notifications$;
  }

  get numberOfNewNotifications$(): Observable<number> {
    return this._notifications$.pipe(
      map((notifications) => {
        if (Array.isArray(notifications)) {
          return notifications.filter(n => !n.isRead).length;
        }

        return 0;
      })
    );
  }

  constructor() {
    this._notificationList = new Array<NotificationModel>();
    this._notifications$ = new BehaviorSubject<NotificationModel[]>(null);
  }

  abstract connect(): void;
  abstract signOut(): void;
  abstract view(notification: NotificationModel): void;
  abstract remove(notification: NotificationModel): void;

  protected _processNotification(notification: NotificationModel): void {
    this._notificationList.unshift(notification);
    this._notificationList = this._notificationList.sort((a, b) => {
      if (a.dateOfNotification > b.dateOfNotification) {
        return -1;
      } else if (a.dateOfNotification < b.dateOfNotification) {
        return 1;
      }
      return 0;
    });

    const newList = this._notificationList.slice(0, Constants.MAXIMUM_NUMBER_OF_DISPLAY_NOTIFICATIONS);
    this._notifications$.next(newList);
  }
}
